import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingItemListView from 'src/sections/packaging-item/view/packaging-item-list-view';

export default function PackagingItemListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Packaging Items</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_PACKAGING_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingItemListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
